<custom-app-bar [hasCloseButton]="true"/>
<div class="content">
    <h1 class="title">{{ 'download_app_modal.title' | translate }}</h1>
    <p>{{ 'download_app_modal.description' | translate }}</p>
    <div class="store-buttons">
        <app-app-store-button
                [type]="appStoreButtonType"
        />
    </div>
</div>